export default document.addEventListener('DOMContentLoaded', function () {
  const scrollerEls = document.querySelectorAll('.card-scroller__wrapper');

  if (scrollerEls.length < 1) return;

  scrollerEls.forEach((scrollerEl) => {
    // Get unique slides in scroller to determine whether the swiper should loop or not
    const uniqueSlides = scrollerEl.querySelectorAll(
      '.swiper-slide:not(.swiper-slide-duplicate)',
    ).length;
    const shouldLoop = uniqueSlides > 3;

    new Swiper(scrollerEl, {
      slidesPerView: 'auto',
      loop: shouldLoop,
      spaceBetween: 32,
      freeMode: true,
      centerInsufficientSlides: true,
      mousewheel: false, // Disabled because this is annyoying #182901008
      navigation: {
        nextEl: '.card-scroller__button--next',
        prevEl: '.card-scroller__button--prev',
      },
      a11y: {
        slideRole: '',
      },
    });

    const makeNonActiveSlidesNotTabbable = () => {
      const nonActiveSlideLinks = scrollerEl.querySelectorAll(
        '.swiper-slide:not(.swiper-slide-active) a',
      );
      nonActiveSlideLinks.forEach((link) => {
        link.setAttribute('tabindex', '-1');
      });
    };

    // Get prev/next btns for this swiper instance
    const prevBtn = scrollerEl.querySelector('.card-scroller__button--prev');
    const nextBtn = scrollerEl.querySelector('.card-scroller__button--next');
    const btns = [prevBtn, nextBtn];

    // Focus on newly active slide when using prev/next buttons
    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        // Get newly active slide
        const activeSlideLink = scrollerEl.querySelector(
          '.swiper-slide.swiper-slide-active a',
        );

        if (activeSlideLink) {
          // Move focus to the newly active slide and make tabbable
          activeSlideLink.setAttribute('tabindex', 0);
          activeSlideLink.focus();
          // Make sure other slides are non-tabbable
          makeNonActiveSlidesNotTabbable();
        }
      });
    });

    // Make all non-active slides non-tabbable on initialisation
    makeNonActiveSlidesNotTabbable();
  });
});
